import React from 'react'
import Icon from 'react-icon-base'

const NotificationsIcon = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m19.8 36.3c-1.8 0-3.3-1.5-3.3-3.3h6.5c0 1.8-1.5 3.3-3.2 3.3z m10.5-9.8l3.2 3.3v1.6h-27.5v-1.6l3.2-3.3v-8.9c0-4.9 3.5-9.2 8.1-10.3v-1.1c0-1.4 1-2.5 2.5-2.5s2.4 1.1 2.4 2.5v1.1c4.6 1.1 8.1 5.4 8.1 10.3v8.9z" />
    </g>
  </Icon>
)

export default NotificationsIcon
